import ProfileUpdateView from "./ProfileUpdateView";
import React from "react";
import { connect } from "react-redux";

const Promise = global.Promise;

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

class ProfileUpdate extends React.Component {
  

  render() {
    return (
      <div className="home-page">
        <div className="container page">
          <div className="row">
            <ProfileUpdateView />

           
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileUpdate);
